export default function MapAdjustBeacon(google, bounds, map, options = {}) {

  gm.prototype = new google.maps.OverlayView();
  function gm(bounds, map, options) {
    this.bounds = bounds
    this.map = map
    this.image = options.floorFile || ''
    this.opacity = options.floorOpacity || 0
    this.angle = options.angle || 0
    this.div = null
    this.observer = null
    this.setMap(map)
  }

  gm.prototype.onAdd = function () {

    const div = document.createElement('div')
    div.style.borderStyle = 'none'
    div.style.borderWidth = '0px'
    div.style.position = 'absolute'

    div.style.transform = 'rotate(' + this.angle + 'deg)'

    // Create the img element and attach it to the div.
    if (this.image) {
      const img = document.createElement('img')
      img.src = this.image
      img.id = 'floorMapImg'
      img.style.width = '100%'
      img.style.height = '100%'
      img.style.position = 'absolute'
      img.style.opacity = this.opacity / 100
      div.appendChild(img)
    }

    this.div = div

    const panes = this.getPanes()
    panes.overlayLayer.appendChild(div)
  }

  gm.prototype.draw = function () {
    const overlayProjection = this.getProjection();
    const sw = overlayProjection.fromLatLngToDivPixel(this.bounds.getSouthWest())
    const ne = overlayProjection.fromLatLngToDivPixel(this.bounds.getNorthEast())
    const div = this.div
    div.style.left = sw.x + 'px'
    div.style.top = ne.y + 'px'
    div.style.width = (ne.x - sw.x) + 'px'
    div.style.height = (sw.y - ne.y) + 'px'
  }

  gm.prototype.onRemove = function () {
    if (this.div && this.div.parentNode) {
      this.div.parentNode.removeChild(this.div)
      this.div = null
    }

    if (this.observer) {
      this.observer.disconnect()
    }
  }

  return new gm(bounds, map, options)
}
